import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ContractorListEnum } from '@constants/global.enum';
import { paginationParams } from '@shared/config/table.config';
import { ContractorsVendorView, columnDefs } from './contractors-list.config';
import { SearchService } from '@services/search.service';
import { VendorService } from '@services/vendor.service';
import { VendorDetails } from '@interfaces/vendor.model';
import { TemplateRef } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { interval, takeWhile } from 'rxjs';
import { GlobalErrorService } from '@services/global-error.service';

@Component({
  selector: 'app-contractors-list',
  templateUrl: './contractors-list.component.html',
  styleUrls: ['./contractors-list.component.scss'],
})
export class ContractorsListComponent implements OnInit {
  customContractorNameColumn!: TemplateRef<any>;

  ContractorListEnum = ContractorListEnum;
  contractorsvendorView: ContractorsVendorView[] = [];
  displayData: ContractorsVendorView[] = [];
  columnDefs = columnDefs;
  paginationParams = paginationParams;
  filterValue: string = '';
  totalCount: number = 0;
  errorMsg: string = ContractorListEnum.NoRecordsTitle;
  isDataLoaded: boolean = false;
  imageSrc: string = 'assets/img/no-data-found.png';
  opened: boolean = false;

  selectedMonth: number = new Date().getMonth() + 1; // Default to current month
  selectedYear: number = new Date().getFullYear(); // Default to current year

  constructor(
    private searchService: SearchService,
    private vendorService: VendorService,
    private cdr: ChangeDetectorRef,
    private router: Router,
    private route: ActivatedRoute,
    public globalError: GlobalErrorService,
  ) {}

  ngOnInit(): void {
    this.route.queryParams.subscribe((params) => {
      const month = params['month'];
      const year = params['year'];
      if (month && year) {
        this.selectedMonth = month;
        this.selectedYear = year;
        this.fetchContractors(month, year);
      } else {
        this.fetchContractors();
      }
    });
  }

  fetchContractors(
    month?: number,
    year?: number,
    additionalFilters?: any,
  ): void {
    this.isDataLoaded = false;
    const currentMonth = month || this.selectedMonth;
    const currentYear = year || this.selectedYear;

    this.vendorService.currentVendor$.subscribe(
      (currentVendor: VendorDetails | null | undefined) => {
        if (currentVendor?.id) {
          this.vendorService.fetchContractorsByVendorId(
            currentVendor.id,
            currentMonth,
            currentYear,
          );

          this.vendorService.contractors$.subscribe({
            next: (signalData) => {
              this.contractorsvendorView = signalData;
              this.displayData = additionalFilters
                ? this.applyAdditionalFilters(signalData, additionalFilters)
                : [...signalData];
              this.totalCount = this.displayData.length;
              this.isDataLoaded = true;
              this.cdr.detectChanges();
            },
            error: (error) => {
              this.isDataLoaded = true;
              this.globalError.logComponentError(error);
            },
          });
        }
      },
    );
  }

  searchContractors(event: KeyboardEvent): void {
    const input = (event.target as HTMLInputElement).value.toLowerCase();
    this.filterValue = input;

    this.displayData = this.searchService.getSearchedData(
      this.contractorsvendorView,
      this.filterValue,
    );
    this.totalCount = this.displayData.length;
    this.cdr.detectChanges();
  }

  clearInput(): void {
    this.filterValue = '';
    this.displayData = [...this.contractorsvendorView];
    this.totalCount = this.displayData.length;
    this.cdr.detectChanges();
  }

  toggleFilter(): void {
    this.opened = !this.opened;
  }

  closeFilter(): void {
    this.opened = false;
  }

  onFilterReset(): void {
    this.displayData = [...this.contractorsvendorView];
    this.totalCount = this.displayData.length;
    this.opened = true;
  }

  onFilterApplied(data: any): void {
    if (data.month) {
      const [selectedMonth, selectedYear] = data.month.split('-');
      this.selectedMonth = Number(selectedMonth);
      this.selectedYear = Number(selectedYear);
      this.fetchContractors(this.selectedMonth, this.selectedYear, data);
    } else if (Array.isArray(data)) {
      this.displayData = data;
      this.filterValue = '';
      this.totalCount = this.displayData.length;
    }
    this.opened = false;
    this.cdr.detectChanges();
  }

  applyAdditionalFilters(
    data: ContractorsVendorView[],
    filters: any,
  ): ContractorsVendorView[] {
    const filteredData = data.filter((contractor) => {
      const statusMatch =
        !filters.status || contractor.status === filters.status;
      const locationMatch =
        !filters.location || contractor.location === filters.location;
      const managerMatch =
        !filters.reportingManager ||
        contractor.reportingManager === filters.reportingManager;

      return statusMatch && locationMatch && managerMatch;
    });
    return filteredData;
  }
  
  navigateToVendorDashboard(): void {
    this.router.navigate(['/vendorflow-dashboard']);
  }
}
